var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.subFormAvailable
    ? _c(
        "div",
        [
          _c(
            "b-row",
            { staticClass: "d-flex align-items-center klippa-subform-header" },
            [
              _c("h2", [_vm._v("\n            Kunde\n        ")]),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "klippa-subform-toggle-btn",
                  attrs: { variant: "primary" },
                  on: { click: _vm.toggleAll },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.someIncluded ? "Alle abwählen" : "Alle auswählen"
                      ) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-row",
                    [
                      _c("csp-klippa-info-card-element", {
                        ref: "fieldFirstName",
                        staticClass: "col-12",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Vorname",
                          property: "firstName",
                          "subform-identifier": _vm.subformIdentifier,
                          type: "text",
                        },
                        on: {
                          "field-hover-changed": (data) => {
                            _vm.$emit("field-hover-changed", data)
                          },
                          "field-inclusion-changed":
                            _vm.onFieldInclusionChangedWithTracking,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("csp-klippa-info-card-element", {
                        ref: "fieldLastName",
                        staticClass: "col-12",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Nachname",
                          property: "lastName",
                          "subform-identifier": _vm.subformIdentifier,
                          type: "text",
                        },
                        on: {
                          "field-hover-changed": (data) => {
                            _vm.$emit("field-hover-changed", data)
                          },
                          "field-inclusion-changed":
                            _vm.onFieldInclusionChangedWithTracking,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("csp-klippa-info-card-element", {
                        ref: "fieldCompanyName",
                        staticClass: "col-12",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Firmenname",
                          property: "companyName",
                          "subform-identifier": _vm.subformIdentifier,
                          type: "text",
                        },
                        on: {
                          "field-hover-changed": (data) => {
                            _vm.$emit("field-hover-changed", data)
                          },
                          "field-inclusion-changed":
                            _vm.onFieldInclusionChangedWithTracking,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("csp-klippa-info-card-element", {
                        ref: "fieldStreet",
                        staticClass: "col-12",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Straße",
                          property: "street",
                          "subform-identifier": _vm.subformIdentifier,
                          type: "text",
                        },
                        on: {
                          "field-hover-changed": (data) => {
                            _vm.$emit("field-hover-changed", data)
                          },
                          "field-inclusion-changed":
                            _vm.onFieldInclusionChangedWithTracking,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("csp-klippa-info-card-element", {
                        ref: "fieldPostalCode",
                        staticClass: "col-12",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "PLZ",
                          property: "postalCode",
                          "subform-identifier": _vm.subformIdentifier,
                          type: "text",
                        },
                        on: {
                          "field-hover-changed": (data) => {
                            _vm.$emit("field-hover-changed", data)
                          },
                          "field-inclusion-changed":
                            _vm.onFieldInclusionChangedWithTracking,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("csp-klippa-info-card-element", {
                        ref: "fieldPlace",
                        staticClass: "col-12",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Ort",
                          property: "place",
                          "subform-identifier": _vm.subformIdentifier,
                          type: "text",
                        },
                        on: {
                          "field-hover-changed": (data) => {
                            _vm.$emit("field-hover-changed", data)
                          },
                          "field-inclusion-changed":
                            _vm.onFieldInclusionChangedWithTracking,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("csp-klippa-info-card-element", {
                        ref: "fieldCountry",
                        staticClass: "col-12",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Land",
                          "options-loader": _vm.loadCountryOptions,
                          property: "country",
                          "subform-identifier": _vm.subformIdentifier,
                          type: "autocomplete",
                        },
                        on: {
                          "field-hover-changed": (data) => {
                            _vm.$emit("field-hover-changed", data)
                          },
                          "field-inclusion-changed":
                            _vm.onFieldInclusionChangedWithTracking,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }